import React from 'react';
import { useParams } from 'react-router-dom';

import EcAccountForm from '@components/shared/ec_accounts/EcAccountForm';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';

import { ecAccountService } from '@services/admin/ecAccountService';
import { salesChannelService } from '@services/admin/salesChannelService';
import { shippingTypeService } from '@services/admin/shippingTypeService';

interface ReferenceOption {
  id: string;
  name?: string;
  [key: string]: unknown;
}

const AdminEcAccountEdit: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const mode: 'create' | 'edit' = (!id || id === 'new') ? 'create' : 'edit';

  // Admin session 鎖單一 merchant；context 的 salesChannels / shippingTypes 已是該 merchant 範圍。
  const merchantData = useMerchantData();
  const salesChannels = (merchantData?.salesChannels ?? []) as ReferenceOption[];
  const shippingTypes = (merchantData?.shippingTypes ?? []) as ReferenceOption[];
  const loading = !!merchantData?.loading;

  return (
    <EcAccountForm
      ecAccountService={ecAccountService}
      salesChannelService={salesChannelService}
      shippingTypeService={shippingTypeService}
      role="admin"
      mode={mode}
      salesChannels={salesChannels}
      shippingTypes={shippingTypes}
      merchantDataLoading={loading}
    />
  );
};

export default AdminEcAccountEdit;
